import { TableCell } from "@material-ui/core";

import { TableActionProps, useTableAction } from "./useTableAction";

const TableAction: TableActionProps = function (props) {
  const { actionLabel, tableAction, orderIndex, isCart, rowSpan } =
    useTableAction(props);

  if (orderIndex !== 0) {
    return null;
  }

  return (
    <TableCell
      className="table-cell"
      style={{
        padding: "30px 10px 30px 10px",
        color: "#2f3953",
        fontSize: "1rem",
        fontFamily: "OpenSans-Regular",
      }}
      {...(isCart ? { rowSpan } : {})}
    >
      {actionLabel === "NA" ? (
        "NA"
      ) : (
        <div
          className="transaction-button d-flex align-items-center mouse-pointer"
          onClick={tableAction}
        >
          <p className="d-none d-xl-block m-0" style={{ whiteSpace: "nowrap" }}>
            {actionLabel}
          </p>
        </div>
      )}
    </TableCell>
  );
};

export default TableAction;
